// lib/usePushNotifications.ts
import { useEffect } from "react";
import { getToken, onMessage } from "firebase/messaging";
import { messaging } from "./firebase";
import { supabase } from "./supabaseClient";

export function usePushNotifications(userId: string | null) {
  useEffect(() => {
    // Native App übernimmt Push selbst – Web-Registrierung überspringen
    if ((window as any).ReactNativeWebView) return;
    if (!userId || !("Notification" in window)) return;

    let unsubscribe: (() => void) | null = null;

    Notification.requestPermission().then(async (permission) => {
      if (permission !== "granted") return;

      try {
        const registration = await navigator.serviceWorker.register("/firebase-messaging-sw.js");

        const currentToken = await getToken(messaging, {
          vapidKey: "BLBMpj-QGt45qj8nG8OeJS9GDGKk4AThrROZ3FHDQ29HsQPkChOdIo8Hv4V5ouGHIV_FSG7CuOwCgiyFMQz7w6Y",
          serviceWorkerRegistration: registration,
        });

        if (currentToken) {
          const deviceInfo = `${navigator.userAgent} (${window.innerWidth}x${window.innerHeight})`;

          const { error } = await supabase.from("user_push_tokens").upsert(
            [{
              user_id: userId,
              token: currentToken,
              platform: "web",
              device_info: deviceInfo,
              updated_at: new Date().toISOString(),
            }],
            { onConflict: "token" }
          );

          if (error) console.error("❌ Fehler beim Speichern des Tokens:", error);
        } else {
          console.warn("⚠️ Kein Token erhalten");
        }
      } catch (error) {
        console.error("❌ Fehler beim Token holen:", error);
      }
    });

    unsubscribe = onMessage(messaging, (payload) => {
      const { title, body } = payload.notification || {};
      if (title && body) {
        new Notification(title, {
          body,
          icon: "/logo192.png",
        });
      }
    });

    return () => {
      if (unsubscribe) {
        unsubscribe();
      }
    };
  }, [userId]);
}
